<template>
  <RestaurantRequestsForm :typeEndPoint="'restaurantRequestsShow'" :dataParams="this.$route.params" />
</template>
<script>
import RestaurantRequestsForm from '@/components/modules/restaurant/requests/form'
export default {
  name: 'RestaurantRequestsEdit',
  components: {
    RestaurantRequestsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/requests/edit.vue